import * as yup from 'yup';

export const addPersonSchema = yup.object().shape({
   
    identificationNumber: yup.string().when('employeeCode', {
        is: (employeeCode: string) => !employeeCode || employeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    employeeCode: yup.string().when('identificationNumber', {
        is: (identificationNumber: string) => !identificationNumber || identificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    })
}, [[ 'employeeCode', 'identificationNumber' ]]
);